module.exports = __webpack_public_path__ + "img/375.41584b2a.jpg";